import React, { useState } from 'react';
import Api from '../../component/Api';
import Template from '../../component/Template';
import { toast, ToastContainer } from 'react-toastify';
const AdminImpersonation = () => {
    const [collegeUserId, setCollegeUserId] = useState('');
    const [studentApaar, setStudentApaar] = useState('');
    const [sfaUserId, setSFAUserId] = useState('');
    const { http } = Api();

    const impersonateCollege = () => {
        http.post('/Admin/impersonatecollege', { college_user_id: collegeUserId })
            .then(res => {
                console.log(res);
                if (res.data.token) {
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('impersonating', 'true');
                    window.location.href = '/#/college/collegedashboard';
                }
            })
            .catch(error => {
                toast.error('Impersonation failed: Please check College User ID');
                console.error('Impersonation failed:', error);
            });
    };

    const impersonateStudent = () => {
        http.post('/Admin/impersonatestudent', { apaar_no: studentApaar })
            .then(res => {
                if (res.data.token) {
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('impersonating', 'true');
                    if (res.data.student_details) {
                        localStorage.setItem('pathway_id', res.data.student_details[0].pathway_id);
                        localStorage.setItem('student_details', JSON.stringify(res.data.student_details));
                    }
                    window.location.href = '/#/studentdashboard';
                }
            })
            .catch(error => {
                toast.error('Impersonation failed : Please check APAAR number');
                console.error('Impersonation failed:', error);
            });
    };


    const impersonateSFA = () => {
        http.post('/Admin/impersonatesfa', { sfa_user_id: sfaUserId })
            .then(res => {
                if (res.data.token) {
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('impersonating', 'true');
                    window.location.href = '/#/sfa/sfausermapping';
                }
            })
            .catch(error => {
                toast.error('Impersonation failed : Please check SFA UserID');
                console.error('Impersonation failed:', error);
            });
    };


    const stopImpersonation = () => {
        http.post('/stopimpersonation')
            .then((response) => {
                localStorage.removeItem('impersonating');
                localStorage.removeItem('token');
                localStorage.clear();



                // Set admin token and data
                if (response.data.admin_token) {
                    localStorage.setItem('token', response.data.admin_token);

                    // Set admin user data
                    if (response.data.admin_user) {
                        localStorage.setItem('username', response.data.admin_user.name);
                        localStorage.setItem('usertype', response.data.admin_user.user_type);
                        localStorage.setItem('id', response.data.admin_user.id);
                        if (response.data.admin_user.college_id) {
                            localStorage.setItem('collegeid', response.data.admin_user.college_id);
                        }
                    }

                    // Redirect to admin dashboard
                    window.location.href = '/#/admin/dashboard';
                } else {
                    // Fallback: clear everything and redirect to login
                    localStorage.clear();
                    window.location.href = '/';
                }
            })
            .catch(error => {
                console.error('Stop impersonation failed:', error);
                // Fallback: clear everything and redirect to login
                localStorage.clear();
                window.location.href = '/';
            });


    };

    return (
        <>

            <ToastContainer />
            <Template>
                <div className="container-fluid py-4">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-8" style={{ width: '90%' }}>
                            <div className="card border">
                                <div className="card-header bg-primary text-white py-3">
                                    <div className="d-flex align-items-center">
                                        <i className="bi bi-person-check-fill fs-4 me-2"></i>
                                        <h6 className="mb-0 fw-bold">Admin Impersonation</h6>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        {/* College Impersonation */}
                                        <div className="col-md-4 mb-3">
                                            <div className="card border h-100">

                                                <div className="card-body">
                                                    <label className="form-label">College User ID</label>
                                                    <div className="input-group mb-3">
                                                        <span className="input-group-text">
                                                            <i className="bi bi-person-badge"></i>
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter College User ID"
                                                            value={collegeUserId}
                                                            onChange={(e) => setCollegeUserId(e.target.value)}
                                                        />
                                                    </div>
                                                    <button
                                                        className="btn btn-imperson-college w-100"
                                                        onClick={impersonateCollege}
                                                        disabled={!collegeUserId.trim()}
                                                    >
                                                        <i className="bi bi-arrow-right-circle me-2"></i>
                                                        Impersonate College
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* SFA Impersonation */}
                                        <div className="col-md-4 mb-3">
                                            <div className="card border h-100">

                                                <div className="card-body">
                                                    <label className="form-label">SFA User ID</label>
                                                    <div className="input-group mb-3">
                                                        <span className="input-group-text">
                                                            <i className="bi bi-person-badge"></i>
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter SFA User ID"
                                                            value={sfaUserId}
                                                            onChange={(e) => setSFAUserId(e.target.value)}
                                                        />
                                                    </div>
                                                    <button
                                                        className="btn btn-imperson-sfa w-100"
                                                        onClick={impersonateSFA}
                                                        disabled={!sfaUserId.trim()}
                                                    >
                                                        <i className="bi bi-arrow-right-circle me-2"></i>
                                                        Impersonate SFA
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* SFA Impersonation End */}

                                        {/* Student Impersonation */}
                                        <div className="col-md-4 mb-3">
                                            <div className="card border h-100">

                                                <div className="card-body">
                                                    <label className="form-label">Student APAAR Number</label>
                                                    <div className="input-group mb-3">
                                                        <span className="input-group-text">
                                                            <i className="bi bi-person-badge"></i>
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Student APAAR Number"
                                                            value={studentApaar}
                                                            onChange={(e) => setStudentApaar(e.target.value)}
                                                        />
                                                    </div>
                                                    <button
                                                        className="btn btn-imperson-student w-100"
                                                        onClick={impersonateStudent}
                                                        disabled={!studentApaar.trim()}
                                                    >
                                                        <i className="bi bi-arrow-right-circle me-2"></i>
                                                        Impersonate Student
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Stop Impersonation */}
                                    {localStorage.getItem("impersonating") && (
                                        <div className="mt-4">
                                            <div className="alert alert-warning mb-0">
                                                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                                Currently impersonating a user
                                                <button
                                                    onClick={stopImpersonation}
                                                    className="btn btn-danger btn-sm float-end"
                                                >
                                                    <i className="bi bi-stop-circle-fill me-1"></i>
                                                    Stop
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Template>
        </>
    );
};

export default AdminImpersonation;